import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledDialogActionButtonWrapper = styled.div`
	width: 100%;

	${breakPoints({
		'1024': `
			width: fit-content;
		`,
	})}
`;

export const StyledSingleImage = styled.img<{ objectFit: string }>`
	width: 100%;
	height: auto;
	object-fit: ${({ objectFit }) => objectFit};
`;
